

/**
 * Modal component
 */

class ModalComponent extends HTMLElement {
  constructor() {
    super();

    const currentModalId = this.getAttribute('id');
    const btnOpenElement = document.querySelectorAll('[data-modal-target="' + currentModalId + '"]');
    const closeModalButton = this.querySelectorAll('[data-close="modal"]');
    const dontShowButton = this.querySelector('tapita-dont-show');

    this.addEventListener('click', this.closeModalComponent);

    btnOpenElement.forEach((element)=>{
      element.addEventListener('click', this.showModal.bind(this));
    });

    if(dontShowButton){
      dontShowButton.addEventListener('click', this.dontShowModalAgain);
    }

    if(sessionStorage.getItem('modal-dont-show-' + currentModalId) === 'false' || sessionStorage.getItem('modal-dont-show-' + currentModalId) === null){
      if(this.getAttribute('data-auto-open') == 'true'){
        let timeDelay = 0;
        const autoOpenModal = this;

        if(autoOpenModal.getAttribute('data-time-delay')){
          timeDelay = autoOpenModal.getAttribute('data-time-delay') * 1000;
        }

        setTimeout(function() {
          autoOpenModal.classList.add('show');
          document.getElementsByTagName('html')[0].classList.add('open-modal');
        }, timeDelay);
      }
    }

    closeModalButton.forEach((element)=>{
      element.addEventListener('click', this.closeModal);
    })
  }

  showModal(e){
    e.preventDefault();

    const modalId = this.getAttribute('id');
    const btnOpenModal = document.querySelector('[data-modal-target="' + modalId + '"]');

    if(btnOpenModal.classList.contains('active')){
      btnOpenModal.classList.remove('active');
      document.getElementsByTagName('html')[0].classList.remove('open-modal');
      this.classList.remove('show');
      return;
    } else {
      btnOpenModal.classList.add('active');
      document.getElementsByTagName('html')[0].classList.add('open-modal');
      this.classList.add('show');
      this.scrollTop = 0;
      return;
    }
    
  }

  closeModal(e) {
    e.preventDefault();

    const closeButton = this;

    const currentModalId = this.closest('tapita-modal-component').getAttribute('id');
    const btnDontShow = this.closest('tapita-modal-component').querySelector('tapita-dont-show');

    if(btnDontShow){
      if(btnDontShow.classList.contains('active')){
        sessionStorage.setItem('modal-dont-show-' + currentModalId,'true');
      } else {
        sessionStorage.setItem('modal-dont-show-' + currentModalId,'false');
      }
    }

    this.closest('tapita-modal-component').classList.remove('show');

    const buttonModal = document.querySelector('[data-modal-target="' + currentModalId + '"]');

    if(buttonModal){
      buttonModal.classList.remove('active');
    }
    
    setTimeout(function() {
      document.getElementsByTagName('html')[0].classList.remove('open-modal');
    }, 200);

    setTimeout(function() {
      if(closeButton.closest('tapita-modal-component').classList.contains('quickview-modal')){
        document.getElementById(currentModalId).remove();
        
        const productModals = document.querySelectorAll('product-modal');
        productModals.forEach((modal)=>{
          modal.remove();
        })
      }
    }, 400);
  }

  closeModalComponent(e) {
    if(e.target !== this){
      return
    } else {
      const currentModal = this;
      const currentModalId = this.getAttribute('id');
      const btnDontShow = this.querySelector('tapita-dont-show');
      const buttonModal = document.querySelector('[data-modal-target="' + currentModalId + '"]');

      if(btnDontShow){
        if(btnDontShow.classList.contains('active')){
          sessionStorage.setItem('modal-dont-show-' + currentModalId,'true');
        } else {
          sessionStorage.setItem('modal-dont-show-' + currentModalId,'false');
        }
      }

      this.classList.remove('show');

      if(buttonModal){
        buttonModal.classList.remove('active');
      }
    
      setTimeout(function() {
        document.getElementsByTagName('html')[0].classList.remove('open-modal');
      }, 200);

      setTimeout(function() {
        if(currentModal.classList.contains('quickview-modal')){
          currentModal.remove();
          const productModals = document.querySelectorAll('product-modal');
          productModals.forEach((modal)=>{
            modal.remove();
          })
        }
      }, 200);
    }
  }

  dontShowModalAgain(){
    this.classList.toggle('active');
  }

}

customElements.define('tapita-modal-component', ModalComponent);

/**
 * Init swiper slider
 */
class SwiperSliderComponent extends HTMLElement {
  constructor() {
    super();
    
    const swiper = this.querySelector('.swiper');
    const optionString = this.querySelector('tapita-slider-options').innerHTML
    const optionsJson = JSON.parse(optionString);
    const nextButton = this.querySelector('.swiper-button-next');
    const prevButton = this.querySelector('.swiper-button-prev');
    const pagination = this.querySelector('.swiper-paginations');

    let options = {
      ...optionsJson,
      "navigation": {
          "nextEl": nextButton,
          "prevEl": prevButton
      },
      "pagination": {
          "el": pagination,
          "clickable": true
      }
    };

    new Swiper(swiper, options);
  }
}

customElements.define('tapita-slider-component', SwiperSliderComponent);

/**
 * Quickview product
 */

class ProductQuickview extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.showQuickview.bind(this));
  }

  showQuickview(){
    const productUrl = this.getAttribute('data-product-url');
    const productId = this.getAttribute('data-product-id');
    const productTitle = this.getAttribute('data-product-title');

    if(this.closest('cart-drawer')){
      this.closest('cart-drawer').classList.remove('animate', 'active');
      document.body.classList.remove('overflow-hidden');
    }
    
    let modalHtml = '';
    modalHtml += '<tapita-modal-component id="product-modal_id-' + productId + '" class="quickview-modal fade" data-position="bottom">';
    modalHtml += '<tapita-modal-dialog class="color-scheme-1 gradient">';
    modalHtml += '<tapita-modal-content>';

    modalHtml += '<tapita-modal-header>';
    modalHtml += '<div class="modal-title">';
    modalHtml += productTitle;
    modalHtml += '</div>';

    modalHtml += '<button class="close-modal" data-close="modal">';
    modalHtml += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path></svg>';
    modalHtml += '</button>';
    modalHtml += '</tapita-modal-header>';

    modalHtml += '<tapita-modal-body>';
    modalHtml += '<div class="modal-body_data-ajax modal-body_loading">';
    modalHtml += '<div class="loader-component"><span class="hidden">Loading...</span></div>';
    modalHtml += '</div>';
    modalHtml += '</tapita-modal-body>';

    modalHtml += '</tapita-modal-content>';
    modalHtml += '</tapita-modal-dialog>';
    modalHtml += '</tapita-modal-component>';

    if(document.getElementById('product-modal_id-' + productId)){
      this.showModal('product-modal_id-' + productId);
    } else{
      this.classList.add('loading');
      document.body.insertAdjacentHTML('beforeend', modalHtml);
      document.getElementsByTagName('html')[0].classList.add('open-modal');

      setTimeout(function() {
        document.getElementById('product-modal_id-' + productId).classList.add('show');
      }, 200);
      
      fetch(productUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const productModal = document.getElementById('product-modal_id-' + productId);
        const productContainer = productModal.querySelector('.modal-body_data-ajax');
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

        productContainer.innerHTML = productElement.innerHTML;

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();
        this.preventVariantURLSwitching();

        productContainer.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });        
      })
      .finally(() => {
        this.classList.remove('loading');
      });
    }

    
  }

  showModal(modalId){
    document.getElementById(modalId).classList.add('show');
    document.getElementsByTagName('html')[0].classList.add('open-modal');
  }

  preventVariantURLSwitching() {
    const productId = this.getAttribute('data-product-id');
    const productModal = document.getElementById('product-modal_id-' + + productId);
    const variantPicker = productModal.querySelector('variant-selects');
    if (!variantPicker) return;

    variantPicker.setAttribute('data-update-url', 'false');
  }
}

customElements.define('tapita-quickview', ProductQuickview);

/**
 * Popup inner product variants
 */
class PopupVariantsInner extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.showVariantsPopup.bind(this));
  }

  showVariantsPopup(){
    let productUrl = this.getAttribute('data-product-url');
    const productId = this.getAttribute('data-product-id');
    const productElement = this.closest('.product-card-wrapper');

    const variantModals = document.querySelectorAll('tapita-modal-variants');

    variantModals.forEach((modalItem)=>{
      modalItem.remove();
    })

    if(productUrl.toLowerCase().includes('pr_prod_strat')){
      const urlArray = productUrl.split('?pr_prod_strat');
      productUrl = urlArray[0] + '?section_id=tapita-variants';
    }

    let modalHtml = '';
    modalHtml += '<tapita-modal-variants id="variants-modal_id-' + productId + '" class="variants-modal scroll-bar fade show">';
      modalHtml += '<div class="variants-content">';
      modalHtml += '<button class="close-modal-variant" data-close="modal-variant"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path></svg></button>';
      modalHtml += '<div class="variants-content-ajax">';
      modalHtml += '<div class="loading__spinner"> <svg class="spinner" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" viewBox="0 0 128 128" xml:space="preserve"><g><path d="M64 9.75A54.25 54.25 0 0 0 9.75 64H0a64 64 0 0 1 128 0h-9.75A54.25 54.25 0 0 0 64 9.75z" fill="currentColor"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="800ms" repeatCount="indefinite"></animateTransform></g></svg></div>';
      modalHtml += '<div>';
      modalHtml += '<div>';
    modalHtml += '</tapita-modal-variants>';

    if(productElement.querySelector('tapita-modal-variants')){
      this.closest('.product-card-wrapper').querySelector('tapita-modal-variants').classList.add('show');
    } else {
      this.classList.add('loading');
      const windowWith = window.innerWidth;

      if(windowWith <= 1024){
        document.body.insertAdjacentHTML('beforeend', modalHtml);
      } else{
        this.closest('.product-card-wrapper').querySelector('.card__inner').insertAdjacentHTML('beforeend', modalHtml);
      }

      fetch(productUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const modalElement = document.querySelector('tapita-modal-variants');
        const modalAjaxContent = modalElement.querySelector('.variants-content-ajax');

        modalAjaxContent.innerHTML = responseText;      
      })
      .finally(() => {
        this.classList.remove('loading');
      });
    }
    
  }
}

customElements.define('tapita-variants', PopupVariantsInner);

/**
 * Popup inner product variants
 */
class PopupVariantsModal extends HTMLElement {
  constructor() {
    super();

    const btnCloseModal = this.querySelector('[data-close="modal-variant"]');
    btnCloseModal.addEventListener('click', this.closeModalVariant.bind(this));
    this.addEventListener('click', this.closeModalVariantComponent);
  }

  closeModalVariant(){
    this.remove();
  }

  closeModalVariantComponent(e){
    if(e.target !== this){
      return
    } else {
      const windowWith = window.innerWidth;

      if(windowWith <= 1024){
        this.remove();
      }
    }
  }

}
customElements.define('tapita-modal-variants', PopupVariantsModal);
/**
 * Tab popup component
 */

class PopupTabs extends HTMLElement {
  constructor() {
    super();

    const btnOpen = document.querySelectorAll('[data-tab-popup-target]');
    
    btnOpen.forEach((btnItem)=>{
      btnItem.addEventListener('click', this.showModal);
    })
    
  }

  showModal(e){
    e.preventDefault();

    const currentModalId = this.getAttribute('data-tab-popup-target');
    const currentModal = document.getElementById(currentModalId)
    const currentTabTrigger = this.getAttribute('data-item-tab-target');

    currentModal.querySelector('[data-tab-target="' + currentTabTrigger + '"]').click()

    document.getElementsByTagName('html')[0].classList.add('open-modal');
    currentModal.classList.add('show');
    this.scrollTop = 0;
  }


}

customElements.define('tapita-popup-tab', PopupTabs);



/**
 * Tabs component
 */
class TabItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.displayTabContainer.bind(this));
  }

  displayTabContainer(event) {
    event.preventDefault();

    const tabContainerTarget = this.getAttribute('data-tab-target');
    const tabAjaxUrl = this.getAttribute('data-ajax-url');

    if(tabAjaxUrl && !this.classList.contains('loaded')){
      this.closest('tapita-tabs-component').classList.add('component-loading');
      this.classList.add('loading');
      
      if(this.classList.contains('active')){
        return;
      } else {
        const ajaxDataElement = this.closest('tapita-tabs-component').querySelector('[data-ajax-content="' + tabContainerTarget + '"]');

        fetch(tabAjaxUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const elementToGet = this.getAttribute('data-ajax-element');
          
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

          if(elementToGet){
            const tabContentHtml = responseHTML.querySelector(elementToGet);
            ajaxDataElement.innerHTML = tabContentHtml.innerHTML;
          } else {
            
            ajaxDataElement.innerHTML = responseText;
          }

        })
        .finally(() => {
          this.activeTabContainer();
          this.classList.add('loaded');
          this.classList.remove('loading');
          this.closest('tapita-tabs-component').classList.remove('component-loading');
        });
      } 
    } else {
      if(this.classList.contains('active')){
        return;
      } else {
        this.activeTabContainer();
      }
    }
  }

  activeTabContainer(){
    const currentTabContainer = this.closest('tapita-tabs-component');
    const tabContainerTarget = this.getAttribute('data-tab-target');

    currentTabContainer.querySelectorAll('tapita-tab-item').forEach((element) => {
        element.classList.remove('active');
    });

    this.classList.add('active');

    currentTabContainer.querySelectorAll('tapita-tab-data').forEach((element) => {
        element.classList.remove('active');
    });

    currentTabContainer.querySelector('[data-tab-container="' + tabContainerTarget + '"]').classList.add('active');
  }
}

customElements.define('tapita-tab-item', TabItem);

/**
 * Accordion component
 */
class AccordionHeader extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.displayAccordionContainer.bind(this));
  }

  displayAccordionContainer(event) {
    event.preventDefault();

    const currentAccordion = this.closest('tapita-accordion-component');
    const currentAccordionItem = this.closest('tapita-accordion-item');

    if(currentAccordion.getAttribute('data-type') == 'group'){
      if(currentAccordionItem.classList.contains('active')){
        currentAccordionItem.classList.remove('active');
        return;
      } else {
        currentAccordion.querySelectorAll('tapita-accordion-item').forEach((element)=>{
          element.classList.remove('active');
        });

        currentAccordionItem.classList.add('active');
        return;
      }
    } else {
      currentAccordionItem.classList.toggle('active');
    }
  }
}

customElements.define('tapita-accordion-title', AccordionHeader);